import styled from 'styled-components';

import { Wix } from './components/integrations/wix';
import { External } from './components/integrations/external';
import { configSelectors } from '../../store';
import { useAppSelector } from '../../lib';
import { EmailToWinnerIntegration } from './components/integrations/email-to-winner';

export const Integrations = () => {
  const isWix = useAppSelector(configSelectors.isWix);
  const isStandalone = useAppSelector(configSelectors.isStandalone);

  return (
    <IntegrationsWrapper>
      {isWix && <Wix />}
      {isStandalone && <EmailToWinnerIntegration />}

      <External />
    </IntegrationsWrapper>
  );
};

const IntegrationsWrapper = styled.div``;
